<template>
  <v-footer
    clipped-right
    color="brand-primary"
    padless
  >
    <v-container fluid>
      <v-row>
        <v-col
          class="pb-0"
          cols="12"
          lg="10"
          offset-lg="1"
        >
          <v-container
            v-if="$vuetify.breakpoint.mdAndUp"
            fluid
            pa-0
          >
            <template v-if="!simple">
              <v-row class="py-2">
                <v-col
                  class="align-content-stretch"
                  cols="6"
                  lg="5"
                  md="4"
                  sm="3"
                  xl="6"
                >
                  <div class="d-flex flex-column justify-space-between fill-height">
                    <router-link
                      :to="{name: 'Home'}"
                      style="line-height: 0"
                    >
                      <img
                        :alt="$t('Common.App.Title')"
                        :src="LogoDarkSvg"
                        height="24"
                      >
                    </router-link>

                    <div
                      class="brand-green-dark--text d-flex"
                      style="position: relative; bottom: 0;"
                    >
                      <div class="text-center">
                        <div class="mt-1">
                          <span class="mr-1">Powered by</span>
                          <a
                            href="https://www.visa.gr/"
                            target="_blank"
                          >
                            <img
                              :alt="$t('Common.App.Title')"
                              height="11"
                              src="../../assets/img/footer/visa.png?no-inline"
                            >
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>

                <v-col>
                  <h4 class="pb-2 font-weight-regular brand-green-dark--text text--lighten-3">
                    {{ $t('Common.Footer.Company.Title') }}
                  </h4>

                  <template v-for="(item, index) in $t('Common.Footer.Company.Items')">
                    <router-link
                      :key="index"
                      :to="item.To"
                      class="d-flex pt-1"
                    >
                      {{ item.Title }}
                    </router-link>
                  </template>
                </v-col>

                <v-col>
                  <h4 class="pb-2 font-weight-regular brand-green-dark--text text--lighten-3">
                    {{ $t('Common.Footer.Stores.Title') }}
                  </h4>

                  <template v-for="(store, idx) in AppStores">
                    <a
                      v-if="!storeIsHidden(store) || !storeIsDisabled(store)"
                      :key="`store-link-${idx}`"
                      class="d-flex pt-1"
                      href="#"
                      @click="onStoreClick(store)"
                    >
                      {{ store.Name }}
                    </a>

                    <div
                      v-if="storeIsDisabled(store)"
                      :key="`store-div-${idx}`"
                      class="grey--text pt-1"
                    >
                      {{ store.Name }}
                    </div>
                  </template>
                </v-col>

                <v-col>
                  <h4 class="pb-2 font-weight-regular brand-green-dark--text text--lighten-3">
                    {{ $t('Common.Footer.Terms.Title') }}
                  </h4>

                  <template v-for="(item, i) in policies">
                    <router-link
                      :key="i"
                      :to="{name: item.to}"
                      class="d-flex pt-1"
                    >
                      {{ item.text }}
                    </router-link>
                  </template>

                  <a
                    class="d-flex pt-1"
                    @click="toggleCookiesPrefs"
                  >
                    {{ $t('Common.Footer.Terms.CookieSettings') }}
                  </a>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col />
              </v-row>
            </template>

            <v-row
              class="align-center py-4"
              no-gutters
            >
              <v-col
                class="pa-3 pl-0"
                cols="3"
                lg="5"
                md="4"
                sm="3"
                xl="6"
              >
                <div class="d-flex brand-green-dark--text">
                  <div>
                    <span>&copy; {{ new Date().getFullYear() }} </span>
                    <img
                      :alt="$t('Common.App.Title')"
                      :src="LogoDarkSvg"
                      class="ml-1"
                      height="11"
                    >

                    <span>&nbsp;-&nbsp;</span>

                    <span class="mr-1">Developed by</span>
                    <a
                      :href="`https://getfoodpro.gr/${$i18n.locale}`"
                      target="_blank"
                    >
                      <span
                        class="font-weight-bold brand-green-dark--text"
                        style="font-size: 14px;"
                      >GETFOOD Pro</span>
                    </a>
                  </div>
                </div>
              </v-col>

              <v-col class="pa-3" />

              <v-col class="pa-3">
                <span class="font-weight-regular brand-green-dark--text text--lighten-3">
                  {{ $t('Common.Footer.FollowUs.Title') }}:
                </span>
              </v-col>

              <v-col class="pa-3">
                <template v-for="(item, index) in $t('Common.Footer.FollowUs.Items')">
                  <v-btn
                    :key="index"
                    :href="item.Link"
                    :label="item.Title"
                    color="primary"
                    depressed
                    icon
                    small
                    target="_blank"
                  >
                    <v-icon>{{ item.Icon }}</v-icon>
                  </v-btn>
                </template>
              </v-col>
            </v-row>
          </v-container>

          <v-container
            v-else
            fluid
            pa-0
          >
            <template v-if="!simple">
              <v-row class="py-2 align-center">
                <v-col class="shrink">
                  <router-link
                    :to="{name: 'Home'}"
                    style="line-height: 0"
                  >
                    <img
                      :alt="$t('Common.App.Title')"
                      :src="LogoDarkSvg"
                      height="24"
                    >
                  </router-link>
                </v-col>

                <v-col cols="grow">
                  <div class="brand-green-dark--text d-flex justify-end">
                    <div class="text-center">
                      <div class="mt-1">
                        <span class="mr-1">Powered by</span>
                        <a
                          href="https://www.visa.gr/"
                          target="_blank"
                        >
                          <img
                            :alt="$t('Common.App.Title')"
                            height="11"
                            src="../../assets/img/footer/visa.png?no-inline"
                          >
                        </a>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-expansion-panels
                    accordion
                    flat
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header class="expansion-panel-header">
                        {{ $t('Common.Footer.Company.Title') }}
                      </v-expansion-panel-header>

                      <v-expansion-panel-content color="brand-primary">
                        <template v-for="(item, index) in $t('Common.Footer.Company.Items')">
                          <router-link
                            :key="index"
                            :to="item.To"
                            class="d-flex pt-1"
                          >
                            {{ item.Title }}
                          </router-link>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header class="expansion-panel-header">
                        {{ $t('Common.Footer.Stores.Title') }}
                      </v-expansion-panel-header>

                      <v-expansion-panel-content color="brand-primary">
                        <template v-for="(store, idx) in AppStores">
                          <a
                            v-if="!storeIsHidden(store) || !storeIsDisabled(store)"
                            :key="`store-link-${idx}`"
                            class="d-flex pt-1"
                            href="#"
                            @click="onStoreClick(store)"
                          >
                            {{ store.Name }}
                          </a>

                          <div
                            v-if="storeIsDisabled(store)"
                            :key="`store-div-${idx}`"
                            class="grey--text pt-1"
                          >
                            {{ store.Name }}
                          </div>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <v-expansion-panel>
                      <v-expansion-panel-header class="expansion-panel-header">
                        {{ $t('Common.Footer.Terms.Title') }}
                      </v-expansion-panel-header>

                      <v-expansion-panel-content color="brand-primary">
                        <template v-for="(item, i) in policies">
                          <router-link
                            :key="i"
                            :to="{name: item.to}"
                            class="d-flex pt-1 "
                          >
                            {{ item.text }}
                          </router-link>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <v-divider />
                </v-col>
              </v-row>
            </template>

            <v-row
              class="align-center"
              no-gutters
            >
              <v-col class="py-2 shrink">
                <span class="font-weight-regular brand-green-dark--text text-no-wrap">
                  {{ $t('Common.Footer.FollowUs.Title') }}:
                </span>

                <div class="my-2">
                  <template v-for="(item, index) in $t('Common.Footer.FollowUs.Items')">
                    <v-btn
                      :key="index"
                      :href="item.Link"
                      :label="item.Title"
                      color="primary"
                      depressed
                      icon
                      small
                      target="_blank"
                    >
                      <v-icon>{{ item.Icon }}</v-icon>
                    </v-btn>
                  </template>
                </div>
              </v-col>

              <v-col
                class="py-2"
                cols="grow"
              >
                <div class="brand-green-dark--text d-flex justify-end">
                  <div class="text-center">
                    <div class="mt-1">
                      <span>&copy; {{ new Date().getFullYear() }}</span>
                      <img
                        :alt="$t('Common.App.Title')"
                        :src="LogoDarkSvg"
                        class="ml-1"
                        height="11"
                      >
                    </div>
                  </div>
                </div>

                <div class="brand-green-dark--text d-flex justify-end">
                  <div class="text-center">
                    <div class="my-3 mt-4">
                      <span class="mr-1">Developed by</span>
                      <a
                        href="https://getfoodpro.gr/el"
                        target="_blank"
                      >
                        <span class="font-weight-bold brand-green-dark--text">GETFOOD Pro</span>
                      </a>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import AppFooterMixin from '@/theme/default/components/app/AppFooter.js'

export default {
  name  : 'AppFooter',
  mixins: [AppFooterMixin],
  data() {
    return {
      policies: [
        {
          text: this.$t('Page.PoliciesTerms.Name'),
          icon: 'mdi-file-document',
          to  : 'PoliciesTerms'
        },
        {
          text: this.$t('Page.PoliciesPrivacy.Name'),
          icon: 'mdi-file-document',
          to  : 'PoliciesPrivacy'
        },
        {
          text: this.$t('Page.PoliciesDsa.Name'),
          icon: 'mdi-file-document',
          to  : 'PoliciesDsa'
        },
        {
          text: this.$t('Page.PoliciesCookies.Name'),
          icon: 'mdi-file-document',
          to  : 'PoliciesCookies'
        },
        {
          text: this.$t('Page.PoliciesReturns.Name'),
          icon: 'mdi-file-document',
          to  : 'PoliciesReturns'
        },
        {
          text: this.$t('Page.PoliciesAllergens.Name'),
          icon: 'mdi-file-document',
          to  : 'PoliciesAllergens'
        }
      ]
    }
  }
}
</script>

<style scoped>

.expansion-panel-header {
  padding: 0;
  background-color: var(--v-brand-green-base);
  color: var(--v-brand-green-dark-base);
  min-height: 42px;
}

:deep(.v-expansion-panel-header--active) {
  color: var(--v-brand-green-dark-lighten3);
}

:deep(.expansion-panel-header .v-expansion-panel-content__wrap) {
  padding: 0;
  background-color: var(--v-brand-green-base);
  color: var(--v-brand-green-dark-base);
}

a:link {
  color: var(--v-brand-green-dark-base);
  font-weight: normal;
  text-decoration: none;
}

a:visited {
  color: var(--v-brand-green-dark-base);
  font-weight: normal;
  text-decoration: none;
}

a:hover {
  color: var(--v-brand-green-dark-lighten3);
  font-weight: normal;
  text-decoration: none;
}

a:active {
  color: var(--v-brand-green-dark-base);
  font-weight: normal;
  text-decoration: none;
}
</style>
